module.exports = __webpack_public_path__ + "static/media/edek5.0a5600d3.png";